module.exports = __webpack_public_path__ + "static/media/footer_tablet@1x.1d17eb68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/planning/footer_tablet@1x.jpg
// module id = 1513
// module chunks = 40